import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import { TimeDuration } from '@/components/Atoms/TimeDuration/TimeDuration';
import Play from '@/components/Icons/Play';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './VideoIndicator.module.css';

export const VideoIndicator: FCl<{ durationSeconds?: number }> = ({ className, durationSeconds }) => (
    <span className={classNames('cds-t-body-small', styles.styledItem, className)}>
        <Icon size={IconSize.SMALL} use={<Play />} />
        {durationSeconds && (
            <TimeDuration
                withIcon={false}
                durationInSeconds={durationSeconds}
                css={`
                    padding-right: var(--size-grid-half);
                `}
            />
        )}
    </span>
);
